import axiosInstance from "../axiosClient";
import {  recording, updateRecordingStatus} from "../config";


export const getRecording = async (name,start_key) => {
   let queryParams = [];
  if (name) queryParams.push(`name=${encodeURIComponent(name)}`);
  if (start_key) queryParams.push(`start_key=${encodeURIComponent(start_key)}`);

  const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';

  return await axiosInstance.get(`${recording}${queryString}`);
  
};


export const handle_Active_recording =  async(data) => {
  return await axiosInstance.patch(updateRecordingStatus,data);
};




